import http from './HttpService';

export type ContentMimeTypes =
    | 'application/pdf'
    | 'text/csv'
    | 'application/msword'
    | 'application/epub+zip'
    | 'image/jpeg'
    | 'image/png'
    | 'application/vnd.ms-excel↵application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    | 'application/xml'
    | 'application/zip'
    | 'application/octet-stream';

export const downloadFile = (
    data: string | ArrayBuffer | ArrayBufferView | Blob,
    filename: string,
    mime: ContentMimeTypes = 'application/octet-stream',
) => {
    const blob = new Blob([data], { type: mime });
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, filename);
        return;
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a') as HTMLAnchorElement;
    link.href = url;
    link.download = filename;
    link.click();
};

export const fetchBlobFromUrl = (url: string): Promise<any> => {
    return http.get(url);
};
